import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import Assessment from "@/pages/Assessment";

const removeEmergentBadge = () => {
  ["#emergent-badge", 'a[href*="emergent.sh"]'].forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      if (el.tagName !== "SCRIPT") el.remove();
    });
  });
};

const Root = () => {
  useEffect(() => {
    removeEmergentBadge();
    const id = setInterval(removeEmergentBadge, 500);
    const stop = setTimeout(() => clearInterval(id), 5000);
    return () => {
      clearInterval(id);
      clearTimeout(stop);
    };
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
